import styled from 'styled-components';

export const BaseTile = styled.div`
  width: 100%;
  padding: 20px;
  background: ${({ theme }) => theme?.tile?.default.background};
  color: ${({ theme }) => theme?.tile?.default.color};

  &.fixed-height-200 {
    height: 200px;
  }

  &.fixed-height-410 {
    height: 410px;
  }
`;

export const Tile = styled(BaseTile)``;

export const TileViewing = styled(BaseTile)`
  width: 100%;
  height: 100%;
  overflow: hidden;

  &:hover {
    cursor: pointer;
  }

  .by-appointment {
    font-size: 14px;
    color: ${({ theme }) => theme?.tile?.viewing.text};
  }

  .title {
    display: block;
    margin-bottom: 10px;
    font-size: 1.4em;
    color: ${({ theme }) => theme?.tile?.viewing.heading};
  }

  .viewing-item {
    display: flex;
    flex-flow: column;
    margin-bottom: 10px;

    .day {
      font-size: 14px;
    }
    .time {
      font-size: 12px;
      color: ${({ theme }) => theme?.tile?.viewing?.time};
    }
  }
`;

export const TileDetails = styled(BaseTile)`
  width: 100%;
  height: 100%;
  padding: 3em;

  .address {
    margin-top: 10px;
    color: ${({ theme }) => theme.tile.details.address};
  }

  span {
    &.location {
      font-size: 0.6em;
      letter-spacing: 2px;
      color: ${({ theme }) => theme.tile.details.county};
    }
    &.details {
      color: ${({ theme }) => theme?.tile.details?.common};
      &.price {
        color: ${({ theme }) => theme.tile.details.price};
      }
    }
    &.details-value {
      color: ${({ theme }) => theme?.tile.details?.common};
      &.price {
        color: ${({ theme }) => theme.tile.details.price};
      }
    }
  }

  .facebook-share {
    svg {
      path {
        fill: ${({ theme }) => theme.tile.details.facebook};
      }
    }
  }
`;

export const TileButton = styled(BaseTile)`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  justify-content: center;
  transition: background 0.15s ease-in-out, color 0.15s ease-in-out;
  padding: 20px;
  border: none;
  outline: none;
  appearance: none;
  font-size: 1.4em;
  text-decoration: none;

  &.large {
    font-family: 'DomaineDispCondRegular', sans-serif;
    padding: 2em 2em;
    text-align: center;
    font-weight: 300;
    font-size: 2em;
    background: ${({ theme }) => theme.tile.button.background};
    color: ${({ theme }) => theme?.tile?.button.color};
  }

  &.small {
    font-size: 1em;
    background: ${({ theme }) => theme?.tile?.button?.background};
    color: ${({ theme }) => theme?.tile?.button?.color};
  }

  &.meldinteressse {
    background: ${({ theme }) => theme?.tile?.button?.background};
    color: ${({ theme }) => theme?.tile?.button?.color};
  }

  &.sold {
    background: ${({ theme }) => theme?.tile?.default?.active};
    color: ${({ theme }) => theme?.tile?.default.activeColor};

    &:hover {
      cursor: initial;
    }
  }

  &:hover {
    cursor: pointer;
    background: ${({ theme }) => theme?.tile?.button?.backgroundHover};
    color: ${({ theme }) => theme?.tile?.button?.colorHover};
  }
`;
